module.exports = __webpack_public_path__ + "static/media/social-integration.9205eb8a.svg";